import React from 'react';
import { Typography, Chip } from '@mui/material';

/**
 * Admit type chip template
 */
export const AdmitTypeTemplate: React.FC<{ admitType?: string }> = ({ admitType }) => {
  return admitType ? (
    <Chip
      label={admitType}
      size="small"
      sx={{ backgroundColor: '#fff3cd', color: '#856404' }}
    />
  ) : (
    <Typography variant="body2" sx={{ color: '#94a3b8' }}>
      -
    </Typography>
  );
};

export default AdmitTypeTemplate;
